import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'How are cookies shipped?',
  answer: 'We ship our cookies fresh, sealed in premium packaging to ensure they arrive perfectly intact and deliciously gooey. We use expedited shipping to get them to your door as fast as possible.'
}, {
  question: 'How long do they stay fresh?',
  answer: 'Our cookies are best enjoyed within 5-7 days of arrival. You can also freeze them for up to 2 months! Just pop them in the oven or microwave for that fresh-baked experience.'
}, {
  question: 'Can I customize my box?',
  answer: 'Absolutely! You can mix and match any 4 of our dangerously stuffed cookies to build your perfect box.'
}, {
  question: 'Where do you deliver?',
  answer: 'We ship nationwide across the United States and Puerto Rico. Local pickup is also available at our Kissimmee location.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-37">
      <div className="text-center mb-12" data-id="element-38">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-purple mb-4" data-id="element-39">
          FAQ
        </h2>
        <p className="text-brand-purple/80 text-lg" data-id="element-40">
          Everything you need to know about our dangerously stuffed cookies.
        </p>
      </div>

      <div className="space-y-4" data-id="element-41">
        {faqs.map((faq, index) => <div key={index} className="bg-white/20 backdrop-blur-xl border border-white/30 rounded-[24px] overflow-hidden shadow-glass transition-all duration-300 hover:bg-white/30" data-id="element-42">
            <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-43">
              <span className="font-bold text-brand-purple text-lg" data-id="element-44">
                {faq.question}
              </span>
              <span className={`text-brand-purple transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-45">
                ▼
              </span>
            </button>

            <AnimatePresence data-id="element-46">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="px-6 pb-5 text-brand-purple/80 leading-relaxed" data-id="element-47">
                  {faq.answer}
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}